import { Component, type ReactNode, type ErrorInfo } from 'react'
import { Link } from 'react-router-dom'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info)
  }

  override render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback
      return (
        <div className="rounded-xl border border-destructive/30 bg-destructive/5 p-6 text-center">
          <p className="text-sm font-medium text-destructive">
            Terjadi kesalahan yang tidak terduga.
          </p>
          {this.state.error?.message && (
            <p className="mt-1 text-xs text-muted-foreground">{this.state.error.message}</p>
          )}
          <Link
            to="/"
            className="mt-3 inline-block text-xs text-primary underline hover:no-underline"
          >
            Kembali ke Dashboard
          </Link>
        </div>
      )
    }
    return this.props.children
  }
}
